import React from 'react';
import { Dropdown } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { ParagraphSmall500 } from 'lib/components/styles/typography';
import { useTheme } from 'styled-components/macro';
import { AutomotiveRoleOptions, OemOptions } from 'lib/api/folderAccess/types';

type Props = {
  setSelectedOem: (value: OemOptions) => void;
  selectedOem?: OemOptions;
  oemDropdownOptions: OemOptions[];
  selectedEntities?: AutomotiveRoleOptions[];
};

export const SelectOem = ({
  setSelectedOem,
  selectedOem,
  oemDropdownOptions,
  selectedEntities,
}: Props) => {
  const themes = useTheme();

  return (
    <Flex
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      gap='8px'
    >
      <Flex gap='10px'>
        <ParagraphSmall500 color={themes.colors.neutral[80]}>
          Select OEM*
        </ParagraphSmall500>
        <Dropdown
          extendStyles={{
            option: {
              padding: '0px',
            },
            menuList: {
              padding: '20px',
              gap: '10px',
              display: 'flex',
              flexDirection: 'column',
              border: '1px',
            },
          }}
          height={40}
          creatable={false}
          className='dropdown'
          placeholder={'OEM'}
          zIndexProp={1}
          value={selectedOem}
          onChange={value => setSelectedOem(value)}
          options={oemDropdownOptions}
          disabled={!selectedEntities?.length}
          formatOptionLabel={(
            data: any,
            formatOptionMeta: { context: 'menu' | 'value' }
          ) => {
            const { context } = formatOptionMeta;
            if (context === 'menu') {
              return (
                <Flex gap='8px' padding='12px 8px 12px 8px' flexDirection='row'>
                  <ParagraphSmall500 width='160px'>
                    {data.label}
                  </ParagraphSmall500>
                </Flex>
              );
            }
            return data.label;
          }}
        />
      </Flex>
    </Flex>
  );
};
